import React from 'react';
import LoginForm from '../../components/auth/login-form';

const LoginAuth: React.FunctionComponent<any> = () => {
    return <LoginForm />;
};

export default LoginAuth;
